<template>
  <VDialog
    ref="dialog"
    :opener="props.opener"
    @dismiss="emit('closeModal', $event)"
  >
    <gsp-dialog-header close="false">
      <h2 v-t="'labels.deleteBank'" />
      <VLoader class="vm-ml-4" v-if="isLoading" />
    </gsp-dialog-header>
    <gsp-dialog-body class="vm-font-2">
      <div class="vm-flex vm-items-center">
        <span class="round-badge badge-accent">
          <gsp-icon>trash-can</gsp-icon></span
        >
        <span
          class="vm-pls-typo-dt-gsp-design-h4 vm-ml-3"
          v-t="'htmlMarkup.confirmDelete'"
        />
      </div>
      <gsp-divider class="vm-mt-8 vm-mb-5" />
      <BankShortDetail
        :data="{
          bankData: props.modelValue.bankData,
          customerProfileName: props.modelValue.customerProfileName,
        }"
      />
    </gsp-dialog-body>
    <gsp-dialog-footer>
      <div class="btn-wrapper reverse">
        <gsp-primary-button
          @click="submitClicked"
          :disabled="userProfileDetailsStore.getters.isOperator || isLoading"
          v-t="'labels.deleteBank'"
          class="gsp-secondary-button-default"
        />
        <gsp-secondary-button
          @click="dialog.emitDismiss"
          v-t="'labels.dontDelete'"
          class="gsp-primary-button-default vm-mr-5"
        />
      </div>
    </gsp-dialog-footer>
  </VDialog>
</template>

<script setup>
import { computed } from "vue";
import BankShortDetail from "@/components/BankShortDetail";
import initModalFeature, {
  modalProps,
  modalEmits,
} from "~/composables/service-modal";
import { getStoreModuleContext } from "~/utils/store";

const userProfileDetailsStore = getStoreModuleContext("userProfileDetails");

const props = defineProps({
  ...modalProps,
  modelValue: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits({
  ...modalEmits,
  submitted: null,
});

const { dialog, isLoading, submitClicked } = initModalFeature({
  props,
  emit,
  onSubmitConfig: {
    dataloaderConfig: {
      methodName: "deleteBank",
      mainArgs: [computed(() => props.modelValue.bankData)],
    },
    emitEventName: "submitted",
    emitEventData: (eventData) => {
      eventData.bankData = props.modelValue.bankData;
      return eventData;
    },
  },
});
</script>
